import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

/*
	When using in a dialog, set a ref to dialog-body and retrieve it using:
	const container = this.$refs.refName.$el
	Pass the container as the second argument of $copyText
*/
Vue.use(VueClipboard)
